import React from "react";


class CNSubmission extends React.Component{
    render(){
return(
    <div className="CN">
            <h3>轴音旋律-AnXiens- 2025 原创歌曲公募活动 从即日起开始！</h3>
    <p>
    活动规则：</p><p>
    - 您拥有歌曲作品的完整版权。
    </p><p>
    - 歌曲时长限制为1分50秒-2分20秒。
    </p><p>
    - 投稿仅限截止日期前未公开过的原创歌曲。
    </p><p>
    - 歌曲可以包含演唱及歌词，语言不限，但歌词需要符合审核及道德标准。如果作品含有歌词，则请在投稿时一并提供歌词原文。
    </p><p>
    - 每位参与者限定投稿3部作品，合作参与时创作者名义与个人参与共用名额。
    </p><p>
    - 参与者需要年满18周岁，未满18周岁的作者需要法定监护人代理签署（以投稿日为基准）。
    </p><p>
    </p><p><br/>
    关于投稿歌曲的处理
    </p><p>
    - 我们将于收到投稿后7个工作日内发送确认回复的电子邮件。
    </p><p>
    - 所有投稿的歌曲都仅被用于本次歌曲投稿活动，并被GLACIA STUDIO严格保密。
    </p><p>
    - 我们将对收到的所有作品进行审核，并可能选取其中一部分用于游戏内使用。选定歌曲的总数量将由GLACIA STUDIO全权决定。
    </p><p>
    - 未被选中的歌曲，我们不会以任何形式使用或公开。
    </p><p>
    - 被选中的歌曲，我们将于审核截止日之前与您联络。您不可在审核截止日之前发布歌曲。
    </p><p>
    - 如果审核截止日前我们仍未与您联络，则之后您可以自行发布您的歌曲。
    </p><p><br/>

    关于版权和签约：
    </p><p>
    - 投稿送出后您仍然拥有歌曲的版权，直到我们联系并与您签约购买版权为止。
    </p><p>
    - 歌曲被选中后，我们将于您签约，并支付授权费购买歌曲的所有权。
    </p><p>
    - 我们将对您提供的所有个人信息严格保密，仅用于签约及歌曲审核，不会用于其他途径。 
    </p><p>
    </p><p>
    投稿截止日期： 2025/7/1
    </p><p>
    审核截止日期： 2025/7/30
    </p><p><br/>

    请按照以下投稿要求及格式提供文件：
    </p><p>
    1.您的真实姓名及邮箱联系方式。
    </p><p>
    2.用于游戏内显示的作曲家名称或乐队名称。若以团队名义参与，请一举列出成员名称。
    </p><p>
    3.歌曲名称。
    </p><p>
    4.曲风。
    </p><p>
    5.歌曲BPM。如果歌曲内包含BPM变化，则需以毫秒或节拍为单位标注出变速节点。
    </p><p>
    6.歌曲介绍。如果有歌词则请在此一并提供。
    </p><p>
    7.音频文件，文件命名格式为：2025AXSubmission_[SongTitle].wav，音频格式为48kHz,24Bit。
    </p><p>
    GLACIA STUDIO拥有对本次活动的最终解释权
    </p><p>
    如有任何问题，请联系此邮箱<a href="https://www.anxiens.com/event/songsubmission2025/">glacia_studio@foxmail.com</a>
    </p><br/><br/>
            </div>
    )
    }
        }

export default CNSubmission